import type {
  IClientPlanApi,
  IClientPlansResponse,
  IClientsResponse,
  IGetClientsParams,
  IClientContact,
  IClientContactsResponse
} from '../../../interfaces/clients';
import {
  GET_CLIENT_CONTACTS_MOCK_RESPONSE,
  GET_CLIENTS_MOCK_RESPONSE,
  GET_CLIENT_PLANS_MOCK_RESPONSE
} from '../../../mocks/clients';
import { HttpService } from '../../http/httpService';

export class Clients {
  static async getClients(brokerId: string, params: IGetClientsParams = {}): Promise<IClientsResponse> {
    const response = await HttpService.get<IClientsResponse>(
      `brokers/${brokerId}/clients`,
      { params },
      GET_CLIENTS_MOCK_RESPONSE()
    );
    return response.data;
  }

  static async getClientPlans(brokerId: string, clientId: number): Promise<IClientPlanApi[]> {
    const response = await HttpService.get<IClientPlansResponse>(
      `brokers/${brokerId}/clients/${clientId}/plans`,
      {},
      GET_CLIENT_PLANS_MOCK_RESPONSE()
    );
    return response.data.plans;
  }

  static async getClientContacts(brokerId: string, clientId: number): Promise<IClientContact[]> {
    const response = await HttpService.get<IClientContactsResponse>(
      `brokers/${brokerId}/clients/${clientId}/contacts`,
      {},
      GET_CLIENT_CONTACTS_MOCK_RESPONSE()
    );
    return response.data.contacts;
  }
}

export default Clients;
